<div *ngIf="visible$ | async" class="tr-connection-alert">
  <div class="middle">
    <div class="alert alert-danger d-flex fade show tr-alert-box">
      <div class="flex-grow-1">
        <span *ngIf="!isNative">
          <strong>Oops.</strong> It looks like there's a problem with your connection.
          <button type="button" class="btn btn-link btn-sm p-0 alert-link ms-2" (click)="reload()">Click here to reload.</button>
        </span>
        <span *ngIf="isNative">
          <strong>Oops.</strong> No internet connection.
        </span>
      </div>
    </div>
  </div>
</div>
